<template>

    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg ">

                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Off The Couch is Closing - </h2>
                            <h2 class="text-white">The Bad, The Ugly, and The Future</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row justify-content-center mt--100">
                    <div class="col-lg-12">
                        <card gradient="white" shadow body-classes="p-lg-5">
                            <div class="text-center mb-4">
                                <img v-lazy="'img/brand/blog/otc-closing/cyborg.png'"  class="img-fluid rounded shadow fixed-size-img">
                            </div>
                            <p>{{post.text1}}</p>
                            <p>{{post.text2}}</p>
                            <p>{{post.text3}}</p>
                            <p>{{post.text4}}</p>
                            <p class="text-warning"><strong>{{post.text5}}</strong></p>
                            <p>{{post.text6}}</p>
                            <p>{{post.text7}}</p>
                            <p class="text-warning"><strong>{{post.text8}}</strong></p>
                            <p>{{post.text9}}</p>
                            <p>{{post.text10}}</p>
                            <p>{{post.text11}}</p>

                            <hr>
                            <div class="row">
                                <div class="ml-3">
                                    <img v-lazy="'img/brand/people/nick.jpg'" alt="Circle image"
                                         class="img-fluid rounded-circle shadow" style="width: 70px;">
                                </div>
                                <div class="ml-2">
                                    <h6 class="font-weight-800">{{post.author}}</h6>
                                    <p>Owner of Off the Couch</p>

                                </div>
                            </div>


                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "OtcClosing",
        data () {
            return {
                post: {
                    text1: "Some of you may have heard the rumors because I’ve always had a problem keeping my mouth shut.  Either way, it’s true – Off The Couch is closing its doors at the end of this year.",
                    text2: "This surprisingly had nothing to do with Covid-19, but because our landlord surprised us with a “We’re destroying this building so you’re being kicked out” email.  This caught us a bit off guard and has just been another note on this brilliant symphony of despair that is 2020.  We had some grandiose plans for this location over the next few years that will sadly have to go on the backburner for a while.",
                    text3: "There is a possibility that we may not even make it to the end of the year since the Covid-19 shutdowns have eaten away at our coffers and despite being open we are burning through the reserves faster than we’re filling them.  I keep delaying the decision to shut the doors early because honestly, I’m a sentimental guy and even this post is super hard to write.",
                    text4: "I want to thank everyone who has supported us with their kind words, their patronage, their encouragement, and for sharing their memories with us.  We really appreciate all of you who kept us in your thoughts, overcame your fears, and trusted us to keep the games safe throughout these crazy times.  Your support has been the major driver that is keeping these doors open as long as possible.",
                    text5: 'To everyone that is asking if we are going to move to a new location, the answer is sadly, “I don’t know yet.”',
                    text6: "The world changed pretty heavily in March 2020 and all of the data we collected over the years doesn’t really mean much anymore.  With California changing dramatically to survive the impact of Covid-19 and with people leaving en masse, it’s been difficult to even attempt to predict what the future may hold.  There is a scenario where we open back up in a new location early 2021, but there is also a possibility that we may take a long break and come back in 2022 with fresh hearts and fresh minds.",
                    text7: "The escape room community is one of the most awesome group of people I’ve ever had the pleasure to be a part of.  We plan to remain a part of it for the rest of our lives and will continue to do our best to help it grow.  We sincerely hope that we will have the opportunity to build you all new games in the future.",
                    text8: "This is definitely not goodbye, but a see you later.",
                    text9: "If you have any questions, concerns, or just want to chat – feel free to reach out to us on Facebook, Instagram, E-mail, or phone.  We always love to hear from you.",
                    text10: "Thank you all again for the last three amazing years.  Off The Couch has been some of the greatest years of my life and it’s all thanks to all the players, OTC Team, and everyone in the escape room community.",
                    text11: "I hope to see you all again someday soon.",
                    tags: ['covid-19', 'announcement', 'closing'],
                    datePosted: "August 20, 2020",
                    author: "Nick",
                    category: "announcements"
                }
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>
    .fixed-size-img {
        width: 90%; /* width of container */
        height: 250px; /* height of container */
        object-fit: cover;
    }
</style>
